import { render, staticRenderFns } from "./DocumentosCandidato.vue?vue&type=template&id=398bea14&scoped=true"
import script from "./DocumentosCandidato.vue?vue&type=script&lang=js"
export * from "./DocumentosCandidato.vue?vue&type=script&lang=js"
import style0 from "./DocumentosCandidato.vue?vue&type=style&index=0&id=398bea14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398bea14",
  null
  
)

export default component.exports